import styled from "@emotion/styled";
import { css, keyframes } from "@emotion/react";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useRecoilValue } from "recoil";
import {
  ArrowUpDownButton,
  FoldArrowRight,
  FoldButton,
  OpenButton,
} from "../../assets/icons/icons";
import { FoldArrowLeft } from "../../assets/icons/icons";
import { accidentState } from "../../atoms/accident";
import RedToastMsg from "../../components/redToastMsg";
import useGetDetectLive from "../../hooks/useGetDetectLive";
import { DetectTodayResult, GetMobilityLive } from "../../types/types";
import KakaoMap from "./kakaoMap";
import UtilBarLeft from "./utilBarLeft";
import UtilBarRight from "./utilBarRight";
import userStorage from "../../utils/userStorage";
import theme from "../../theme";
import useGetDetectLiveClustering3 from "../../hooks/useGetDetectLiveClustering3";
import { NotificationBadge } from "../../components/common/NotificationBadge";
import { AccidentAudio } from "../../components/common/AccidentAudio";
import { AccidentBlink } from "./AccidentBlink";
import { useWindowSize } from "@reactuses/core";
import { Pagination } from "@mui/material";
import { useGetMonitoring } from "../../hooks/utils/useGetMonitoring";
import { handleKeyDown } from "../../utils/util";
import { DailyWarning } from "../../components/DailyWarning";
import { PageLayout } from "../../components/PageLayout";
import { format } from "date-fns";
import { normalizeLongitude } from "../../utils/mapUtils";
import { useI18n } from "../../locales";
import { MobilityUsageReportModal } from "../../components/mobilityUsageReportModal/MobilityUsageReportModal";

const { sm, md, lg } = theme.screen;

const Control: React.FC<{}> = () => {
  const { t } = useI18n();
  const { width } = useWindowSize();
  const routeId = process.env.REACT_APP_ROUTE_ID ?? "";
  const user = userStorage.get();
  const accident = useRecoilValue(accidentState);
  const [mobFilter, setMobFilter] = useState(-1);
  const [searchKey, setSearchKey] = useState("");
  const [mobilityCode, setMobilityCode] = useState(-1);
  const [showNum, setShowNum] = useState(false);
  const [showNokNum, setShowNokNum] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [page, setPage] = useState(0);
  const [minWidth, setMinWidth] = useState("500px");
  const [activeRight, setActiveRight] = useState(true); // 실시간 감지내역 탭이 기본 활성화
  const [activeUp, setActiveUp] = useState(false); // sm 사이즈용
  const navigate = useNavigate();
  const [mapContentsToggle, setMapContentsToggle] = useState(false);
  const divEl = useRef<HTMLDivElement>(null);
  const wrapperDivEl = useRef<HTMLDivElement>(null);
  const [selectedInfo, setSelectedInfo] = useState<
    GetMobilityLive | DetectTodayResult
  >();
  const [select, setSelect] = useState("");
  const location = useLocation();
  const [leftFold, setLeftFold] = useState(false); // 접히면 2 / 열리면 0,1 (초기값 열림 0)
  const [rightFold, setRightFold] = useState(false);
  const [listDataLimit, setListDataLimit] = useState(100);
  const { id: paramsPid } = useParams<{ id: string }>(); // 외부에서 전달받은 pid
  const [center, setCenter] = useState({
    lat: Number(user?.latitude) || 37.5665, // 서울 기본값
    lng: Number(user?.longitude) || 126.9780, // 서울 기본값
  });
  const [mapBound, setMapBound] = useState<kakao.maps.LatLngBounds>(); // 지도의 현재 범위
  const [accidentData, setAccidentData] = useState<
    GetMobilityLive | undefined
  >(); // 토스트 메시지
  const [isPNVisible, setIsPNVisible] = useState(true); // 모바일 페이지네이션 활성화 조건
  const [openReport, setOpenReport] = useState(false); // 농기계 사용 리포트 모달 상태
  const [level, setLevel] = useState(
    window.innerWidth > theme.screen.md && user?.area === "00000"
      ? 12
      : window.innerWidth > theme.screen.md && user?.area.length === 5
      ? 9
      : window.innerWidth > theme.screen.md && user?.area.length === 2
      ? 11
      : window.innerWidth <= theme.screen.md && user?.area === "00000"
      ? 13
      : 10
  );
  const [startDate, setStartDate] = useState<Date | null>();
  const [endDate, setEndDate] = useState<Date | null>();
  const [eventCode, setEventCode] = useState(0);
  const [groupSubCode, setGroupSubCode] = useState("");
  const [runStat, setRunStat] = useState<
    "crash" | "warn" | "run" | "stop" | undefined
  >(undefined);

  // 사고 관제용 데이터
  const { data: liveData, isLoading: liveDataIsLoading } =
    useGetMonitoring();
  // const liveData = queryClient.getQueryData<GetMobilityLiveList>([
  //   "Monitoring",
  // ]);

  const { data, isLoading } = useGetDetectLive({
    area: user?.area as string,
    // 지도용 데이터 호출 (페이징 X)
    mobility_code: mobilityCode,
    searchKey,
    swlng: level <= 7 ? mapBound?.getSouthWest().getLng() : undefined,
    swlat: level <= 7 ? mapBound?.getSouthWest().getLat() : undefined,
    nelng: level <= 7 ? mapBound?.getNorthEast().getLng() : undefined,
    nelat: level <= 7 ? mapBound?.getNorthEast().getLat() : undefined,
    ...(startDate && {
      startDate: format(new Date(startDate as Date), "yyyy-MM-dd"),
    }),
    ...(endDate && {
      endDate: format(new Date(endDate as Date), "yyyy-MM-dd"),
    }),
    event_code: eventCode,
    ...(groupSubCode &&
      groupSubCode !== "all" && { groupId: groupSubCode }),
  });

  const { data: listData, isLoading: listIsLoading } = useGetDetectLive({
    // 리스트용 데이터 호출 (페이징 O)
    area: user?.area as string,
    mobility_code: mobilityCode,
    runStat,
    searchKey,
    page: page,
    limit: listDataLimit,
    ...(startDate && {
      startDate: format(new Date(startDate as Date), "yyyy-MM-dd"),
    }),
    ...(endDate && {
      endDate: format(new Date(endDate as Date), "yyyy-MM-dd"),
    }),
    event_code: eventCode,
    ...(groupSubCode &&
      groupSubCode !== "all" && { groupId: groupSubCode }),
  });

  const [clustererLevel2, setClustererLevel2] = useState(50); // 클러스터2용 레벨

  const { data: levelData3, isLoading: clustererIsLoading } =
    useGetDetectLiveClustering3({
      mobility_code: mobilityCode,
      searchKey,
      eps: clustererLevel2,
      level: 1,
      minPts: 1,
      area: user?.area as string,
      swlng: level >= 7 && mapBound ? normalizeLongitude(mapBound.getSouthWest().getLng()) : undefined,
      swlat: level >= 7 ? mapBound?.getSouthWest().getLat() : undefined,
      nelng: level >= 7 && mapBound ? normalizeLongitude(mapBound.getNorthEast().getLng()) : undefined,
      nelat: level >= 7 ? mapBound?.getNorthEast().getLat() : undefined,
      ...(startDate && {
        startDate: format(new Date(startDate as Date), "yyyy-MM-dd"),
      }),
      ...(endDate && {
        endDate: format(new Date(endDate as Date), "yyyy-MM-dd"),
      }),
      event_code: eventCode,
      ...(groupSubCode &&
        groupSubCode !== "all" && { groupId: groupSubCode }),
    });

  const [bookmarkMarker, setBookmarkMarker] = useState({
    lat: Number(user?.latitude),
    lng: Number(user?.longitude),
    visible: false,
  });

  const onClickBtn = (el: string) => {
    // utilBarLeft 조회버튼 SearchKey
    setSearchKey(el);
  };

  const onClickBtn2 = (el: number) => {
    // utilBarLeft 조회버튼 MobilityCode
    setMobilityCode(el);
  };

  const onClickStatBtn = (el: "crash" | "warn" | "run" | "stop" | undefined) => {
    // utilBarLeft 조회버튼 MobilityCode
    console.log(el);
    setRunStat(el);
  };

  const onClickRightFold = () => {
    if (rightFold) {
      setRightFold(false);
    } else {
      setRightFold(true);
    }
  };
  const onClickLeftFold = () => {
    if (leftFold) {
      setLeftFold(false);
    } else {
      setLeftFold(true);
    }
  };

  const handleSetCenterMarker = (
    lat: string | number,
    lng: string | number
  ) => {
    if (width <= theme.screen.sm) {
      // 모바일 사이즈
      setTimeout(() => {
        setCenter({
          lat: Number(lat) + 0.0015,
          lng: Number(lng),
        });
      }, 100);
      return;
    } else if (width < theme.screen.md) {
      setTimeout(() => {
        setCenter({
          lat: Number(lat) + 0.002,
          lng: Number(lng),
        });
      }, 100);
      return;
    } else if (width < theme.screen.lg && !leftFold) {
      setTimeout(() => {
        setCenter({
          lat: Number(lat) + 0.0035,
          lng: Number(lng) - 0.002,
        });
      }, 100);
      return;
    } else if (width > theme.screen.lg && !leftFold && rightFold) {
      setTimeout(() => {
        setCenter({
          lat: Number(lat) + 0.0035,
          lng: Number(lng) - 0.002,
        });
      }, 100);
      return;
    } else {
      setTimeout(() => {
        setCenter({
          lat: Number(lat) + 0.0035,
          lng: Number(lng),
        });
      }, 100);
      return;
    }
  };

  const handleClickDevice = (el: GetMobilityLive | null) => {
    if (el === null) {
      setSelect("");
      setSelectedInfo(undefined);
      return;
    }
    setActiveUp(false);
    setLevel(3);
    setSelect(el.device_pid);
    setShowNokNum(false);
    setShowNum(false);
    setSelectedInfo(el);
    setIsButtonVisible(false);
    handleSetCenterMarker(el.latitude, el.longitude);
    setBookmarkMarker({
      lat: 36.3927,
      lng: 128.2719,
      visible: false,
    });
  };

  const handleChange = (
    // 페이지네이션
    _: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value - 1);
    handleClickDevice(null);
  };

  const handleFoldOpen = () => {
    // 양쪽 유틸바 한번에 토글하는 버튼
    if (rightFold || leftFold) {
      setRightFold(false);
      setLeftFold(false);
    } else {
      setRightFold(true);
      setLeftFold(true);
    }
  };

  // 토스트 메시지 띄울 사고의 첫번째 데이터 설정
  useEffect(() => {
    if (
      liveData &&
      liveData.list &&
      liveData.list.filter((el) => el.event_accident !== "정상").length > 0
    ) {
      const target = liveData.list.filter(
        (el) => el.event_accident !== "정상"
      )[0];
      setAccidentData(target);
    } else {
      setAccidentData(undefined);
    }
  }, [liveData]);

  useEffect(() => {
    // home에서 금일 감지 내역 list 클릭시 전달받는 location
    // mobileList에서 지도에서보기 아이콘 클릭시
    if (location && location.state) {
      if (location.state.from === "home") {
        // console.log(location.state.data?.device_pid);
        setLevel(3);
        setSelect(location.state.data?.device_pid);

        if (liveData && liveData?.list.length > 0) {
          const target = listData?.list.filter(
            (el) => el.device_pid === location.state.data?.device_pid
          );
          if (!target || target.length === 0) return;
          setSelectedInfo(target[0]);
          handleSetCenterMarker(target[0].latitude, target[0].longitude);
        }
      }
    }
  }, [location, width, liveData]);

  useEffect(() => {
    // 접히면 2 / 열리면 0,1 (초기값 열림 0)
    if (leftFold && rightFold) {
      // 양쪽 다 접혔을 때
      setMinWidth("530px"); // 서치바 결과 모달 열렸을때 기준
      return;
    }
    if (leftFold && !rightFold) {
      // 왼쪽만 접혔을 때
      setMinWidth("950px"); // 서치바 결과 모달 열렸을때 기준
      return;
    }
    if (rightFold && !leftFold) {
      //오른쪽만 접혔을 때
      setMinWidth("890px");
      return;
    }
    // 양쪽 다 열림
    setMinWidth("1360px");
  }, [leftFold, rightFold]);

  useEffect(() => {
    if (!activeUp) {
      divEl.current?.scrollTo({
        top: 0,
      });
      wrapperDivEl.current?.scrollTo({
        // 오버플로우됐을때 하단에 컨텐츠 클릭시 스크롤 밀려있음 방지
        top: 0,
      });
    }
  }, [activeUp]);

  useEffect(() => {
    if (location) {
      if (location.state) {
        if (location.state.selectedTab) {
          setActiveUp(true);
        }
      }
    }
  }, [location]);

  useEffect(() => {
    if (!data || !paramsPid) return;
    const filteredData = data.list.filter(
      (el) => el.device_pid === paramsPid
    );
    // console.log(data.list.filter((el) => el.device_pid === paramsPid));
    if (filteredData.length > 0) {
      // 필터된 데이터가 여러개면 첫번째 데이터 선택
      const result = filteredData[0];
      setSelectedInfo(result);
      setSelect(result.device_pid);
      setLevel(3);
      handleSetCenterMarker(result.latitude, result.longitude);
    }
    if (filteredData.length === 0) {
      window.alert(t.control.noData);
    }
    navigate(`${routeId}`/*`${routeId}/control`*/, { replace: true });
  }, [paramsPid, data]);

  useEffect(() => {
    if (!divEl.current) return;
    let timeout: NodeJS.Timeout;
    // 스크롤 이벤트 핸들러
    const handleScroll = () => {
      // 페이지네이션을 숨김
      setIsPNVisible(false);

      // 스크롤이 멈추면 페이지네이션을 다시 표시
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setIsPNVisible(true);
      }, 1000); // 스크롤이 1초 동안 멈추면 페이지네이션을 표시
    };

    // 스크롤 이벤트 리스너 등록
    divEl.current.addEventListener("scroll", handleScroll);

    // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    return () => {
      clearTimeout(timeout);
      divEl?.current?.removeEventListener("scroll", handleScroll);
    };
  }, [divEl]);

  // console.log(data);
  // console.log("select", select);
  // console.log("selectedInfo", selectedInfo);
  // console.log("NorthEast", mapBound?.getNorthEast().getLat());
  // console.log("SouthWest", mapBound?.getSouthWest().getLng());
  // console.log(mapBound?.getSouthWest().getLng());
  // console.log(mapBound?.getSouthWest().getLat());
  // console.log(mapBound?.getNorthEast().getLng());
  // console.log(mapBound?.getNorthEast().getLat());
  // console.log("accident", accident);
  // console.log(liveData);
  // console.log(user?.grade);
  // console.log(paramsPid);

  return (
    <PageLayout
      // subHeader={width > md && <SubHeader onClickBtn={onClickBtn} />}
      // bodyPaddingBottom={width > md ? undefined : "0px"}
      withoutBody
      withoutFooter
      isFull
    >
      <Wrapper
        minWidth={minWidth}
        leftFold={leftFold}
        activeUp={activeUp}
        ref={wrapperDivEl}
        id="control-wrapper"
      >
        <DailyWarning />
        <AccidentBlink data={liveData} />
        <AccidentAudio accident={accident} />

          {/* <VerticalNavContainer>
          <VerticalNav
            mapContentsToggle={mapContentsToggle}
            setMapContentsToggle={setMapContentsToggle}
            setIsButtonVisible={setIsButtonVisible}
          />
        </VerticalNavContainer> */}

          <KakaoMapContainer activeUp={activeUp}>
            {/* 양쪽 유틸바 동시에 토글하는 버튼 */}
            {(rightFold == leftFold || (!rightFold && !leftFold)) && (
              <CloseButton onClick={handleFoldOpen}>
                {rightFold || leftFold ? <OpenButton /> : <FoldButton />}
              </CloseButton>
            )}
            <KakaoMap
              showNokNum={showNokNum}
              setShowNokNum={setShowNokNum}
              showNum={showNum}
              setShowNum={setShowNum}
              data={data?.list}
              isLoading={isLoading}
              center={center}
              setCenter={setCenter}
              setLevel={setLevel}
              select={select}
              setSelect={setSelect}
              level={level}
              selectedInfo={selectedInfo}
              setSelectedInfo={setSelectedInfo}
              leftFold={leftFold}
              rightFold={rightFold}
              isButtonVisible={isButtonVisible}
              setIsButtonVisible={setIsButtonVisible}
              bookmarkMarker={bookmarkMarker}
              setBookmarkMarker={setBookmarkMarker}
              levelData2={levelData3}
              setClustererLevel2={setClustererLevel2}
              clustererIsLoading={clustererIsLoading}
              mapContentsToggle={mapContentsToggle}
              setMapContentsToggle={setMapContentsToggle}
              mapBound={mapBound}
              setMapBound={setMapBound}
              handleClickDevice={handleClickDevice}
              activeRight={activeRight}
              openReport={openReport}
              setOpenReport={setOpenReport}
              openReportModal={() => setOpenReport(true)}
            />
          </KakaoMapContainer>

        <ContainerForMd activeUp={activeUp} openReport={openReport} ref={divEl}>
          <ArrowUpDownButtonContainer
            onClick={() => {
              setActiveUp((prev: boolean) => !prev);
              setIsButtonVisible(false);
            }}
            activeUp={activeUp}
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDown}
          >
            <ArrowUpDownButton active={activeUp} />
          </ArrowUpDownButtonContainer>

          {/* 모바일 디바이스용 탭 버튼 */}
          <TabWrapper>
            <Tab3
              style={{ position: "relative" }}
              activeRight={activeRight}
              isLive={location.pathname === `${routeId}/`/*`${routeId}/control`*/}
              onClick={() => {
                navigate(`${routeId}/`/*`${routeId}/control`*/);
                setActiveRight(true);
              }}
            >
              {t.control.realtimeDetectionHistory}
              {user?.grade === 2 &&
                typeof liveData !== "undefined" &&
                liveData?.list?.some(
                  (el) =>
                    el.accident_status_admin === 0 ||
                    el.battery_status_admin === 0 ||
                    el.danger_status_admin === 0 ||
                    el.steal_status_admin === 0 ||
                    el.userarea_status_admin === 0
                ) && <NotificationBadge />}
            </Tab3>
            <Tab
              isLive={location.pathname === `${routeId}/`/*`${routeId}/control`*/}
              activeRight={activeRight}
              onClick={() => {
                navigate(`${routeId}/`/*`${routeId}/control`*/);
                setActiveRight(false);
              }}
            >
              {t.control.farmMachineryList}
            </Tab>
            {/* <Tab2
              isLive={location.pathname === `${routeId}/control`}
              onClick={() =>
                navigate(`${routeId}/control/past`, {
                  state: { selectedTab: "past" },
                })
              }
            >
              과거 감지내역 조회
            </Tab2> */}
          </TabWrapper>

          <LeftWrapperContainer
            activeUp={activeUp}
            activeRight={activeRight}
          >
            <LeftWrapper>
              <UtilBarLeft
                data={listData?.list}
                allData={liveData?.list}
                isLoading={listIsLoading}
                total_page={listData?.total_page}
                total_items={listData?.total_items}
                mobFilter={mobFilter}
                setMobFilter={setMobFilter}
                onClickBtn={onClickBtn}
                onClickBtn2={onClickBtn2}
                selectedInfo={selectedInfo}
                leftFold={leftFold}
                page={page}
                setPage={setPage}
                activeRight={activeRight}
                setActiveRight={setActiveRight}
                listDataLimit={listDataLimit}
                setListDataLimit={setListDataLimit}
                handleClickDevice={handleClickDevice}
                setEventCode={setEventCode}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setGroupSubCode={setGroupSubCode}
                onClickStatBtn={onClickStatBtn}
                runStat={runStat}
              />
              {/* 769 ~  */}
              <PaginationWrapper leftFold={leftFold}>
                {!listIsLoading && listData?.total_page !== undefined && listData?.total_page !== null && listData.total_page > 0 && (
                  <Pagination
                    count={listData?.total_page}
                    page={page + 1}
                    siblingCount={2}
                    onChange={handleChange}
                    size="medium"
                  />
                )}
              </PaginationWrapper>

                <LeftFoldButton
                  onClick={() => onClickLeftFold()}
                  setFold={leftFold}
                >
                  <LeftIconWrapper>
                    {leftFold ? <FoldArrowRight /> : <FoldArrowLeft />}
                  </LeftIconWrapper>
                </LeftFoldButton>
              </LeftWrapper>
            </LeftWrapperContainer>

          <RightWrapperContainer
            activeRight={activeRight}
            activeUp={activeUp}
          >
            <RightWrapper activeRight={activeRight}>
              <UtilBarRight
                setLevel={setLevel}
                data={liveData?.list}
                setCenter={setCenter}
                select={select}
                setSelect={setSelect}
                selectedInfo={selectedInfo}
                setSelectedInfo={setSelectedInfo}
                rightFold={rightFold}
                leftFold={leftFold}
                setIsButtonVisible={setIsButtonVisible}
                setBookmarkMarker={setBookmarkMarker}
                isLoading={liveDataIsLoading}
                activeRight={activeRight}
                setActiveRight={setActiveRight}
                setActiveUp={setActiveUp}
              />

                <RightFoldButton
                  onClick={() => onClickRightFold()}
                  setFold={rightFold}
                >
                  <RightIconWrapper>
                    {rightFold ? <FoldArrowLeft /> : <FoldArrowRight />}
                  </RightIconWrapper>
                </RightFoldButton>
              </RightWrapper>
            </RightWrapperContainer>
          </ContainerForMd>

          <RedToastMsg
            open={!!accidentData}
            accidentDate={accidentData?.event_accident as string}
          />

          {openReport && (
            <MobilityUsageReportModal
              data={selectedInfo}
              open={openReport}
              setOpen={setOpenReport}
              id={select}
            />
          )}

          {/* ~768 */}
          {!listIsLoading && listData?.total_page !== undefined && listData?.total_page !== null && listData.total_page > 0 && (
            <PaginationWrapperMd
              activeUp={activeUp}
              isPNVisible={isPNVisible}
            >
              <Pagination
                count={listData?.total_page}
                page={page + 1}
                siblingCount={2}
                onChange={handleChange}
                size="small"
              />
            </PaginationWrapperMd>
          )}
        </Wrapper>
      </PageLayout>
  );
};

const Wrapper = styled.div<{
  minWidth?: string;
  leftFold?: boolean;
  activeUp?: boolean;
}>`
  width: 100vw;
  background-color: gray;
  display: flex;
  position: absolute;

  @media (max-width: ${sm}px) {
    height: calc(var(--vh, 1vh) * 100);
    min-height: -webkit-fill-available;
    position: fixed;
    flex-direction: column;
    min-width: 320px;
    overflow-y: ${({ activeUp }) => (activeUp ? "auto" : "hidden")};
    overflow-x: hidden;
    ::-webkit-scrollbar {
      display: none;
    }
    @supports (-webkit-touch-callout: none) {
      height: -webkit-fill-available;
    }
  }

  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    min-height: -webkit-fill-available;
    position: fixed;
    flex-direction: column;
    height: calc(var(--vh, 1vh) * 100);
    min-width: 320px;
    /* overflow: hidden; */
    overflow-y: ${({ activeUp }) => (activeUp ? "auto" : "hidden")};
    overflow-x: hidden;
    ::-webkit-scrollbar {
      display: none;
    }
    @supports (-webkit-touch-callout: none) {
      height: -webkit-fill-available;
    }
  }

  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    min-width: ${({ leftFold }) => (leftFold ? "480px" : "none")};
    height: calc(var(--vh, 1vh) * 100 - 76px);
    /* min-height: calc(var(--vh, 1vh) * 100 - 76px); */
    min-height: calc(var(--vh, 1vh) * 100 - 76px);
    overflow: hidden;
  }

  @media (min-width: ${lg + 1}px) {
    min-width: ${({ minWidth }) => minWidth};
    height: calc(var(--vh, 1vh) * 100 - 76px);
    overflow: hidden;
  }
`;

const LeftWrapper = styled.div`
  // 유틸바 Wrapper
  @media (max-width: ${md}px) {
    position: relative;
  }

  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    left: 0px;
    position: absolute;
    z-index: 4;
  }

  @media (min-width: ${lg + 1}px) {
    left: 0px;
    position: absolute;
    z-index: 4;
  }
`;

const RightWrapper = styled.div<{ activeRight?: boolean }>`
  // 유틸바 Wrapper
  right: 0px;
  position: absolute;
  z-index: 3;

  @media (max-width: ${md}px) {
    left: 0px;
    z-index: ${({ activeRight }) => (activeRight ? `30` : `-1`)};
    width: 100%;
    height: 100%;
  }

  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    /* left: 80px; */
    left: 0px;
    z-index: ${({ activeRight }) => (activeRight ? `10` : `-1`)};
  }
`;

const utilBarRightClose = keyframes`
from{
  right:440px;
}
to{
  right:0px;
}
`;
const utilBarRightOpen = keyframes`
from{
  right:0px;
}
to{
  right:440px;
}
`;
const RightFoldButton = styled.button<{ setFold?: boolean }>`
  @media (max-width: ${md}px) {
    display: none;
  }

  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    display: none;
  }

  @media (min-width: ${lg + 1}px) {
    //margin-right: 20px;
    height: 50px;
    width: 23px;
    top: calc(50vh - 60px);
    border: none;
    right: 420px;
    background: ${theme.color.white};
    border-radius: 10px 0px 0px 10px;
    box-shadow: -6px 4px 10px rgba(0, 0, 0, 0.25);
    position: absolute;
    cursor: pointer;
    z-index: -1;
    &:hover {
      box-shadow: -6px 4px 10px rgba(0, 0, 0, 0.32);
      background: ${theme.color.neutral_200};
    }
    ${({ setFold }) =>
      setFold
        ? css`
            animation: ${utilBarRightClose} 0.5s ease;
          `
        : !setFold
        ? css`
            animation: ${utilBarRightOpen} 0.5s ease;
          `
        : null}
    animation-fill-mode:both;
  }
`;
const utilBarLeftClose = keyframes`
from{
  left:420px;
}
to{
  left:0px;
}
`;
const utilBarLeftOpen = keyframes`
from{
  left:0px;
}
to{
  left:420px;
}
`;
const LeftFoldButton = styled.button<{ setFold?: boolean }>`
  height: 50px;
  width: 23px;
  top: calc(50vh - 60px);
  left: 420px;
  border: none;
  background: ${theme.color.white};
  border-radius: 0px 10px 10px 0px;
  box-shadow: 6px 4px 10px rgba(0, 0, 0, 0.25);
  position: absolute;
  cursor: pointer;
  z-index: 0;
  &:hover {
    box-shadow: 6px 4px 10px rgba(0, 0, 0, 0.32);
    background: ${theme.color.neutral_200};
  }
  ${({ setFold }) =>
    setFold
      ? css`
          animation: ${utilBarLeftClose} 0.5s ease;
        `
      : !setFold
      ? css`
          animation: ${utilBarLeftOpen} 0.5s ease;
        `
      : null}
  animation-fill-mode:both;

  @media (max-width: ${md}px) {
    display: none;
  }
`;

const LeftIconWrapper = styled.div`
  position: absolute;
  left: 2px;
  top: 14px;
`;

const RightIconWrapper = styled.div`
  
  display: flex;
  justify-content: center;
  //position: absolute;
  right: 2px;
  top: 14px;
`;

const CloseButton = styled.button`
  cursor: pointer;
  position: absolute;
  z-index: 6;
  border: none;
  background-color: ${theme.statusColor.MAIN};
  color: white;
  padding: 10px;
  border-radius: 20px;
  font-size: small;
  bottom: 0px;
  left: calc(50% + 40px);
  transform: translate(-50%, -50%);

  @media (max-width: ${lg}px) {
    display: none;
  }
`;

const RightWrapperContainer = styled.div<{
  activeRight?: boolean;
  activeUp?: boolean;
}>`
  @media (max-width: ${md}px) {
    display: ${({ activeRight }) => (activeRight ? `block` : `none`)};
    width: 100%;
    height: 100%;
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    position: absolute;
    left: 0;
  }
  @media (min-width: ${lg + 1}px) {
    position: absolute;
  }
`;

const LeftWrapperContainer = styled.div<{
  activeUp?: boolean;
  activeRight?: boolean;
}>`
  display: flex;
  flex-direction: column;
  left: 0;

  @media (max-width: ${md}px) {
    width: 100%;
    height: 100%;
    transition: 200ms;
    display: ${({ activeRight }) => (!activeRight ? `block` : `none`)};
  }
`;

const KakaoMapContainer = styled.div<{ activeUp?: boolean }>`
  width: 100%;
  /* height: calc(var(--vh, 1vh) * 100); */
  height: 100%;
  position: relative;
  z-index: 1; // ContainerForMd(z-index: 31)보다 낮지만, 자식 요소들이 더 높은 z-index를 가질 수 있도록
`;

// const VerticalNavContainer = styled.div`
//   z-index: ${theme.zindex.verticalNav};
//   @media (max-width: ${md}px) {
//     position: fixed;
//     top: 0px;
//     min-width: 320px;
//     width: 100%;
//   }
// `;

const ArrowUpDownButtonContainer = styled.div<{
  activeUp?: boolean;
}>`
  @media (max-width: ${md}px) {
    transition: 200ms;
    height: 50px;
    width: 100%;
    z-index: ${theme.zindex.arrowBtnMd};
    background-color: ${theme.color.neutral_50};
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    display: none;
  }
  @media (min-width: ${lg + 1}px) {
    display: none;
  }
`;

const TabWrapper = styled.div`
  @media (max-width: ${md}px) {
    padding: 20px 24px;
    display: flex;
    gap: 20px;
    border-bottom: 1px solid ${theme.color.neutral_200};
    top: 0;
    z-index: ${theme.zindex.tabBtnMd};
    padding: 20px 10px;
    padding-top: 5px;
    gap: 5px;
    justify-content: space-between;
    background-color: ${theme.color.neutral_50};
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    display: none;
  }

  @media (min-width: ${lg + 1}px) {
    display: none;
  }
`;

const Tab = styled.button<{ isLive?: boolean; activeRight?: boolean }>`
  // 농기계 목록
  /* width: 175px; */
  /* width: 30%; */
  width: 45%;
  height: 40px;
  background-color: ${({ activeRight }) =>
    !activeRight
      ? `${theme.statusColor.MAIN}`
      : `${theme.color.neutral_200}`};
  color: ${({ activeRight }) =>
    !activeRight ? `${theme.color.white}` : `${theme.color.neutral_500}`};
  border: none;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    background: ${({ activeRight }) =>
      !activeRight
        ? `${theme.statusColor.MAIN_HOVER}`
        : `${theme.color.neutral_300}`};
  }
  @media (max-width: 523px) {
    font-size: ${theme.fontSize.FONT_3};
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    font-size: small;
  }
  @media (min-width: ${lg + 1}px) {
    width: 45%;
    background-color: ${({ isLive }) =>
      isLive ? `${theme.statusColor.MAIN}` : `${theme.color.neutral_200}`};
    color: ${({ isLive }) =>
      isLive ? `${theme.color.white}` : `${theme.color.neutral_500}`};
  }
`;

// const Tab2 = styled.button<{ isLive?: boolean }>`
//   // 과거 감지내역 조회
//   height: 40px;
//   width: 30%;
//   background-color: ${({ isLive }) =>
//     isLive ? `${theme.color.neutral_200}` : `${theme.statusColor.MAIN}`};
//   color: ${({ isLive }) =>
//     isLive ? `${theme.color.neutral_500}` : `${theme.color.white}`};
//   border: none;
//   font-weight: 500;
//   font-size: 15px;
//   line-height: 20px;
//   border-radius: 3px;
//   cursor: pointer;
//   &:hover {
//     background: ${({ isLive }) =>
//       isLive
//         ? `${theme.color.neutral_300}`
//         : `${theme.color.neutral_200}`};
//   }
//   @media (max-width: 523px) {
//     font-size: ${theme.fontSize.FONT_3};
//   }
//   @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
//     font-size: 11px;
//   }
//   @media (min-width: ${lg + 1}px) {
//     width: 45%;
//   }
// `;

const Tab3 = styled.button<{ isLive?: boolean; activeRight?: boolean }>`
  // 실시간 감지내역
  display: none;
  /* width: 30%; */
  width: 45%;
  height: 40px;
  background-color: ${({ activeRight }) =>
    activeRight
      ? `${theme.statusColor.MAIN}`
      : `${theme.color.neutral_200}`};
  color: ${({ activeRight }) =>
    activeRight ? `${theme.color.white}` : `${theme.color.neutral_500}`};
  border: none;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    background: ${({ activeRight }) =>
      activeRight
        ? `${theme.statusColor.MAIN_HOVER}`
        : `${theme.color.neutral_300}`};
  }
  @media (max-width: 523px) {
    font-size: ${theme.fontSize.FONT_3};
  }
  @media (max-width: ${md}px) {
    display: block;
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    display: block;
    font-size: small;
  }
`;

const ContainerForMd = styled.div<{
  activeUp?: boolean;
  openReport?: boolean;
}>`
  @media (max-width: ${sm}px) {
    ::-webkit-scrollbar {
      display: none;
    }
  }
  @media (max-width: ${md}px) {
    position: absolute;
    top: ${({ activeUp }) =>
      activeUp ? `50px` : `calc(var(--vh, 1vh) * 100 - 50px)`};
    min-width: 320px;
    z-index: ${({ openReport }) => 
      openReport ? theme.zindex.customModal - 1 : theme.zindex.controlListMd};
    width: 100%;
    transition: 200ms;
    transform: translateY(0) translateY(-50px);
    min-height: ${({ activeUp }) =>
      activeUp ? `calc(var(--vh, 1vh) * 100 - 50px)` : `50px`};
    background-color: ${theme.color.neutral_50};
    overflow-y: ${({ activeUp }) => (activeUp ? "auto" : "hidden")};
    overflow-x: hidden;
    flex-shrink: 0;
    pointer-events: ${({ openReport }) => openReport ? "none" : "auto"};
  }
  
  @media (min-width: ${md + 1}px) {
    pointer-events: ${({ openReport }) => openReport ? "none" : "auto"};
    z-index: ${({ openReport }) => 
      openReport ? theme.zindex.customModal - 1 : "auto"};
  }
`;

const leftClose = keyframes`
from{
  left:0px;
}
to{
  left:-420px;
}
`;

const leftOpen = keyframes`
from{
  left:-420px;
}
to{
  left:0px;
}
`;

const PaginationWrapper = styled.div<{ leftFold: boolean }>`
  height: 62px;
  background-color: ${theme.color.neutral_50};
  display: flex;
  justify-content: center;
  box-shadow: 6px 4px 10px rgba(0, 0, 0, 0.25);
  padding-top: 15px;
  padding-bottom: 15px;
  transition: 200ms;
  position: absolute;
  top: calc(var(--vh, 1vh) * 100 - 62px - 76px);
  width: 420px;
  ${({ leftFold }) =>
    leftFold
      ? css`
          animation: ${leftClose} 0.5s ease;
        `
      : css`
          animation: ${leftOpen} 0.5s ease;
        `}
  animation-fill-mode:both;
  box-shadow: 6px 4px 10px rgba(0, 0, 0, 0.25);

  @media (max-width: ${md}px) {
    display: none;
  }

  nav ul {
    // 스크롤생겼을때 두줄로 변하는거 방지
    flex-wrap: nowrap;
  }
`;

const PaginationWrapperMd = styled.div<{
  activeUp?: boolean;
  isPNVisible?: boolean;
}>`
  height: 56px;
  transform: ${({ isPNVisible }) =>
    isPNVisible ? `translateY(0)` : `translateY(56px)`};
  background-color: ${theme.color.neutral_50};
  display: flex;
  justify-content: center;
  padding-top: 15px;
  padding-bottom: 15px;
  z-index: ${({ activeUp }) => (activeUp ? "100" : "-1")};
  position: fixed;
  top: calc(100% - 56px);
  width: 100%;
  transition: 200ms;

  @media (min-width: ${md + 1}px) {
    display: none;
  }
`;
export default Control;
